<template>
  <div class="d-flex align-items-center">
    <template v-if="organisationName">{{ organisationName }}</template>
    <template v-else-if="!addingOrganisation">
      <button class="btn btn-primary btn-sm" @click="addingOrganisation = true">
        Link Organisation
      </button>
    </template>
    <template v-else>
      <input
        :class="['form-control w-25 h-25 custom-control-inline mr-1', invalidCode ? 'is-invalid' : '']"
        v-model="organisationCode"
        placeholder="Enter Code"
        type="text"
      />
      <button class="btn btn-primary btn-sm mx-1" @click="addOrganisation()">
        {{ isSubmitting ? '...' : 'Submit' }}
      </button>
      <button class="btn btn-danger btn-sm mx-1" @click="reset()">
        Cancel
      </button>
    </template>
    <span v-if="errorMsg" class="error-msg pl-2">{{errorMsg}}</span>
  </div>
</template>

<script>
import userService from "../services/user.service";

export default {
  name: "OrganisationAssigner",
  props: ["organisationName"],
  data() {
    return {
      addingOrganisation: false,
      organisationCode: "",
      invalidCode: false,
      errorMsg: "",
      isSubmitting: false,
    };
  },
  methods: {
    addOrganisation() {
      if (this.isSubmitting)
        return;
      
      this.invalidCode = false;
      this.errorMsg = "";
      
      if (this.organisationCode.trim().length < 1) {
        this.invalidCode = true;
        return;
      }

      this.isSubmitting = true;

      userService.assignOrganisation(this.organisationCode)
        .then(() => this.$emit('assigned'))
        .catch(err => this.errorMsg = err)
        .finally(() => {
          this.addingOrganisation = false;
          this.organisationCode = "";
          this.isSubmitting = false;
        })
    },
    reset() {
      this.addingOrganisation = false;
      this.organisationCode = "";
      this.invalidCode = false;
      this.errorMsg = "";
      this.isSubmitting = false;
    }
  },
};
</script>

<style scoped>
.error-msg {
  color: var(--isim-danger);
  font-size: small;
}
</style>
